// extracted by mini-css-extract-plugin
export default {"container":"navigation_container__ZYM5C","return-link":"navigation_return-link__+x6Yq"};